<template>
    <div class="delivery-list">
      <el-empty
        v-if="!deliveryList.length"
        description="Багц / хүргэлт олдсонгүй"
        :image-size="72"
      />
      <el-card
        v-for="(item, index) in deliveryList"
        :key="item.id || index"
        class="delivery-card"
        shadow="hover"
        :body-style="{ padding: '0px' }"
      >
          <el-row>
            <el-col>
              <div class="p-3 cursor delivery-card__body">
                <el-row>
                  <el-col :span="16" v-if="item.code">
                    <div class="m-b-5 delivery-card__code">Код: {{ item.code }}</div>
                  </el-col>
                  <el-col :span="16" v-if="item.phone">
                    <div class="m-b-5 blue_text">{{ item.phone }}</div>
                  </el-col>
                  <el-col :span="6" v-if="item.hvrgvvleh_ognoo">
                    {{ item.hvrgvvleh_ognoo.split('T')[0] }}
                  </el-col>
                  <el-col :span="16" v-if="progressCode === '130'">
                    <div>Тоо: {{ item.DeliveryDetail ? item.DeliveryDetail.length : 0 }}</div>
                    <div v-if="item.delivery_price">Хүргэлтийн үнэ: {{ item.delivery_price | formatCurrency() }}</div>
                  </el-col>
                  <el-col :span="6">
                    <span v-if="item.is_ready === false" class="red_color">Бэлдээгүй</span>
                    <span v-if="item.is_ready === true" class="green_color">Бэлдсэн</span>
                  </el-col>
                  <el-col v-if="progressCode === '210'">
                    <span v-if="item.package_price">Үнэ: {{ item.package_price | formatCurrency() }}</span>
                  </el-col>
                  <el-col class="m-t-10">
                    <hr>
                  </el-col>
                  <el-col v-if="progressCode === '210'">
                    <span v-if="item.jin" class="text_size">Жин: {{ item.jin | formatCurrencyJin() }}</span>
                  </el-col>
                  <el-col v-if="progressCode === '210'">
                    <span v-if="item.urt" class="text_size">Урт: {{ item.urt }}</span>
                  </el-col>
                  <el-col v-if="progressCode === '210'">
                    <span v-if="item.undur" class="text_size">Өндөр: {{ item.undur }}</span>
                  </el-col>
                  <el-col v-if="progressCode === '210'">
                    <span v-if="item.urgun" class="text_size">Өргөн: {{ item.urgun }}</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="24" class="p-3 delivery-card__actions">
                <el-button type="primary" size="small" class="w-100" @click="openDeliveryDetailDialog(item)">Дэлгэрэнгүй</el-button>
                <div class="m-t-10" v-if="progressCode === '130'">
                  <el-button type="warning" size="small" class="w-100" @click="changeDeliveryStatus(item)">Салбараас авах</el-button>
                </div>
                <div class="m-t-10" v-if="progressCode === '210'">
                  <el-button type="warning" size="small" class="w-100" @click="handleOpenPackage(item)">Хэмжээ, үнэ</el-button>
                </div>
                <div class="m-t-10" v-if="progressCode === '210'">
                  <el-button type="danger" size="small" class="w-100" @click="deletePackage(item.id)">Устгах</el-button>
                </div>
              </el-col>
          </el-row>
        </el-card>
        <DeliveryDetailDialog v-if="this.$root.deliveryDetailDialog" :selectedDelivery="this.delivaryDetail" @refreshDeliveryList="getDeliveryList"></DeliveryDetailDialog>
      <el-dialog title="Багцын үнэ, хэмжээ" :visible.sync="this.packageDialog" :before-close="handleClosePackage" width="350px" center>
        <el-form>
          <el-form-item label="Ачааны үнэ">
            <el-input v-model="packageDetail.package_price" type="number" placeholder="Ачааны үнэ оруулна уу"></el-input>
          </el-form-item>
          <el-form-item label="Ачааны жин">
            <el-input v-model="packageDetail.jin" type="number" placeholder="Ачааны жин оруулна уу"></el-input>
          </el-form-item>
          <el-form-item label="Ачааны урт">
            <el-input v-model="packageDetail.urt" type="number" placeholder="Ачааны урт оруулна уу"></el-input>
          </el-form-item>
          <el-form-item label="Ачааны өндөр">
            <el-input v-model="packageDetail.undur" type="number" placeholder="Ачааны өндөр оруулна уу"></el-input>
          </el-form-item>
          <el-form-item label="Ачааны өргөн">
            <el-input v-model="packageDetail.urgun" type="number" placeholder="Ачааны өргөн оруулна уу"></el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-button class="w-100" type="success" @click="changeMeasurement">Хадгалах</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </template>

<script>
import services from '@/helpers/services'
import DeliveryDetailDialog from '@/views/Dialog/DeliveryDetailDialog.vue'

export default {
  data () {
    return {
      deliveryList: [],
      delivaryDetail: null,
      searchQuery: null,
      packageDialog: false,
      packageDetail: {}
    }
  },
  components: {
    DeliveryDetailDialog
  },
  props: {
    progressCode: {
      type: String
    }
  },
  created () {
    this.initData()
    this.getDeliveryList()
  },
  watch: {
    progressCode: {
      handler (newVal) {
        console.log('transacProgressCode солигдлоо:', newVal)
        this.deliveryList = []
        this.getDeliveryList() // ✅ Автомат ажиллуулах
      },
      immediate: true
    }
  },
  methods: {
    async deletePackage (data) {
      try {
        await this.$confirm('Та багц устгахдаа итгэлтэй байна уу?', 'Анхааруулга', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })

        this.$root.fullScreenLoading = true
        const payload = { id: data }

        const response = await services.deletePackage(payload)

        this.$root.fullScreenLoading = false

        if (response.type === 'success') {
          this.getDeliveryList()
          this.$notify({
            title: 'Амжилттай',
            message: 'Багц амжилттай устгагдлаа.',
            type: 'success',
            duration: 3000
          })
        }
      } catch (error) {
        this.$root.fullScreenLoading = false
        console.error('Алдаа:', error)
      }
    },
    async changeMeasurement () {
      try {
        this.$root.fullScreenLoading = true
        const payload = { id: this.packageDetail.id, package_price: this.packageDetail.package_price, urt: this.packageDetail.urt, undur: this.packageDetail.undur, urgun: this.packageDetail.urgun, jin: this.packageDetail.jin }
        await services.changeMeasurement(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.$root.fullScreenLoading = false
              this.getDeliveryList()
              this.handleClosePackage()
              this.$notify({
                title: 'Амжилттай',
                message: 'Хүсэлт амжилттай',
                type: 'success',
                duration: 3000
              })
            }
          }).catch((error) => {
            this.error = error
            console.error('Алдаа:', error)
            this.$root.fullScreenLoading = false
          })
      } catch (error) {
        alert(error)
        console.error('Алдаа:', error)
        this.$root.fullScreenLoading = false
      }
    },
    handleClosePackage () {
      this.packageDialog = false
    },
    handleOpenPackage (data) {
      this.packageDialog = true
      this.packageDetail = data
    },
    initData () {
      this.searchQuery = this.search_query
    },
    async getDeliveryList () {
      try {
        this.$root.fullScreenLoading = true
        const payload = { searchQuery: this.search_query, progress_code: this.progressCode }
        await services.getDeliveryList(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.deliveryList = response.data
            }
          }).catch((error) => {
            this.error = error
            console.error('Алдаа:', error)
            this.$root.fullScreenLoading = false
          })
      } catch (error) {
        alert(error)
        console.error('Алдаа:', error)
        this.$root.fullScreenLoading = false
      }
      this.$root.fullScreenLoading = false
    },
    openDeliveryDetailDialog (data) {
      this.delivaryDetail = data
      this.$root.deliveryDetailDialog = true
    },
    changeDeliveryStatus (data) {
      try {
        this.$confirm('Та төлөв өөрчлөхдөө итгэлтэй байна уу?', 'Анхааруулга', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        }).then(() => {
          this.$root.fullscreenLoading = true
          const payload = { progress_code: '140', dataList: data }
          services.changeDeliveryStatus(payload)
            .then((response) => {
              this.$root.fullscreenLoading = false
              this.$notify({
                title: 'Амжилттай',
                message: 'Төлөв амжилттай өөрчлөгдлөө.',
                type: 'success',
                position: 'top-left'
              })
              this.getDeliveryList()
            })
            .catch((error) => {
              alert(error)
              console.error('Aldaa:', error)
              this.$root.fullscreenLoading = false
            })
        })
      } catch (error) {
        alert(error)
        console.error('Алдаа:', error)
        this.$root.fullScreenLoading = false
      }
    }
  }
}
</script>

<style>
  .text_size {
    font-size: 10px;
  }
  .delivery-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .delivery-card {
    border-radius: 14px !important;
    border: 1px solid #e2e8f0 !important;
    overflow: hidden;
  }
  .delivery-card__code {
    font-weight: 600;
    color: #2563eb;
    font-size: 15px;
  }
  .delivery-card__actions .el-button {
    border-radius: 10px !important;
  }
  .blue_text { color: #409EFF; }
  .red_color { color: #dc2626; font-weight: 500; }
  .green_color { color: #059669; font-weight: 500; }
</style>
